import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { history } from 'consts/routes';

//@ts-ignore
if (window.Cypress) {
  //@ts-ignore
  window.testHistory = history;
}

interface RouterProviderProps {
  children: React.ReactNode;
}

const RouterProvider = ({ children }: RouterProviderProps) => (
  <ConnectedRouter history={history}>{children}</ConnectedRouter>
);

export default RouterProvider;
